const BusinessType = {
  SoleProprietorship: "Sole Proprietorship",
  Corporation: "Corporation",
  Partnership: "Partnership",
  Opc: "OPC"
};

export default BusinessType;
